package com.myrestaurants.sharedmodels

enum class Wish {
    NotSpecified,
    Yes,
    No;

    val label: String
        get() = when(this) {
            NotSpecified -> "Not Specified"
            Yes      -> "Yes"
            No   -> "No"
        }
}